import FolderPlus from '../../src/legacy/FolderPlus';
export default FolderPlus;
